/**
 * @fileoverview Conteúdo de cada seção da área de Configurações (id do
 * registry.js → componente). Cada seção recebe { area, ctx, onDirtyChange }:
 * os formulários com botão Salvar avisam por onDirtyChange quando há
 * alterações não salvas.
 * - `settings` / `company`: a seção usa as configurações / a empresa da área (a
 *   área só busca o que alguma seção visível usa);
 * - `autosave`: o cabeçalho avisa que as alterações se salvam sozinhas;
 * - `standalone`: a seção não espera a carga da área (busca os próprios dados
 *   ou mostra o carregando só onde precisa);
 * - `wide`: a seção usa a largura maior (tabelas, como a da equipe).
 */

import React from "react";

import BillingOverview from "../../../components/BillingOverview";
import CompanyDataForm from "../../../components/CompanyDataForm";
import DepartmentsManager from "../../../components/DepartmentsManager";
import JobRolesManager from "../../../components/JobRolesManager";
import MfaPersonalManager from "../../../components/MfaPersonalManager";
import MfaPolicyManager from "../../../components/MfaPolicyManager";
import TeamAccess from "../../../components/TeamAccess";
import Calls from "./Calls";
import Conversations from "./Conversations";
import Indicators from "./Indicators";
import Modules from "./Modules";
import Notifications from "./Notifications";
import QuickReplies from "./QuickReplies";
import Schedules from "./Schedules";

// O formulário pode editar contas irmãs do grupo (seletor): só reflete na área
// o que foi salvo na PRÓPRIA conta.
const CompanyData = ({ area, onDirtyChange }) => (
  <CompanyDataForm
    company={area.company}
    onDirtyChange={onDirtyChange}
    onSaved={(updated) => {
      if (updated?.id === area.company?.id) area.updateCompany(updated);
    }}
  />
);

const CompanySecurity = ({ area, onDirtyChange }) => (
  <MfaPolicyManager
    companyId={area.company?.id}
    initialPolicy={area.company?.mfaPolicy}
    onDirtyChange={onDirtyChange}
    onSaved={(mfaPolicy) => area.updateCompany({ mfaPolicy })}
  />
);

const SECTIONS = {
  security: { component: MfaPersonalManager, standalone: true },
  schedules: { component: Schedules, company: true, standalone: true },
  conversations: { component: Conversations, settings: true, autosave: true },
  "quick-replies": { component: QuickReplies, settings: true, autosave: true },
  indicators: { component: Indicators, settings: true, autosave: true },
  calls: { component: Calls, settings: true, autosave: true },
  notifications: { component: Notifications, settings: true, autosave: true },
  modules: { component: Modules, settings: true, autosave: true },
  company: { component: CompanyData, company: true },
  "job-roles": { component: JobRolesManager, standalone: true },
  departments: { component: DepartmentsManager, standalone: true, wide: true },
  "team-access": { component: TeamAccess, standalone: true, wide: true },
  "company-security": { component: CompanySecurity, company: true },
  billing: { component: BillingOverview, standalone: true },
};

export default SECTIONS;
